export default __webpack_public_path__ + "static/media/mrswe.d544d4b6.jpeg";